var React = require('react');

function InfoCampaign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.23256 24C1.66202 24 1.14729 23.7688 0.688372 23.3063C0.229457 22.8438 0 22.325 0 21.75V2.25C0 1.675 0.229457 1.15625 0.688372 0.69375C1.14729 0.23125 1.66202 0 2.23256 0H12.6884L14.9209 2.25H27.5349C28.1054 2.25 28.6202 2.48125 29.0791 2.94375C29.538 3.40625 29.7674 3.925 29.7674 4.5H13.9535L11.7209 2.25H2.23256V21.75L6.02791 6.75H32L28.0186 22.275C27.8698 22.875 27.5969 23.3125 27.2 23.5875C26.8031 23.8625 26.2946 24 25.6744 24H2.23256ZM4.57674 21.75H25.8605L28.986 9H7.70233L4.57674 21.75Z","fill":"#212121"}));
}

InfoCampaign.defaultProps = {"width":"32","height":"24","viewBox":"0 0 32 24","fill":"none"};

module.exports = InfoCampaign;

InfoCampaign.default = InfoCampaign;
